export var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["Slack"] = "slack";
    NotificationChannel["Email"] = "email";
    NotificationChannel["Teams"] = "teams";
})(NotificationChannel || (NotificationChannel = {}));
//# sourceMappingURL=notification.channel.js.map